import axios from "axios";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import "./Style/globalValidasiEror.scss";
import Url from "../global";

const FormAddRiwayatJabatan = () => {
  const [jabatan, setJabatan] = useState("");
  const [tglSK, setTglSK] = useState("");
  // const [masaKerja, setMasaKerja] = useState("");
  const [status, setStatus] = useState("");
  const [msg, setMsg] = useState("");


  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [setError] = useState(null);

  const {
    register,
    reset,
    trigger,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const PdfViewer = ({ fileUrl }) => {
    return (
      <div>
        {fileUrl ? (
          <embed
            src={fileUrl}
            type="application/pdf"
            width="70%"
            height="600px"
          />
        ) : (
          <p>No PDF file uploaded</p>
        )}
      </div>
    );
  };

  const handleChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile && selectedFile.type === "application/pdf") {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
    } else {
      setFile(null);
      setError("File harus berupa PDF");
    }
  };

  const saveRiwayatJabatan = async (e) => {
    if (file) {
      const formData = new FormData();
      formData.append("strJabatan", jabatan);
      formData.append("dateTglSK", tglSK);
      formData.append("strStatus", status);
      formData.append("pdfFile", file);

      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }

      // for (let i = 0; i < fileSertifikasi.length; i++) {
      //   formData.append("files", fileSertifikasi[i]);
      // }

      try {
        await axios.post(`${Url}/riwayat_jabatans`, formData, {
          headers: {
            "Content-type": "multipart/form-data",
          },
        });
        navigate("/riwayat-jabatan");
        reset();
      } catch (error) {
        if (error.response) {
          setMsg(error.response.data.msg);
        }
      }
    }
  };

  return (
    <div>
      <h1 className="title">Riwayat Jabatan</h1>
      <h2 className="subtitle">Add New Riwayat Jabatan</h2>

      <div className="card is-shadowless">
        <div className="card-content">
          <div className="content">
            <form className="box" onSubmit={handleSubmit(saveRiwayatJabatan)}>
              <p className="has-text-centered">{msg}</p>

              <div className="field">
                <label className="label">Jabatan</label>
                <div className="control">
                  <input
                    type="text"
                    className={`input ${errors.jabatan && "invalid"}`}
                    {...register("jabatan", {
                      required: {
                        value: true,
                        message: "Jabatan Wajib Di isi!",
                      },
                      minLength: {
                        value: 3,
                        message: "minimal 3 karakter",
                      },
                    })}
                    onKeyUp={() => {
                      trigger("jabatan");
                    }}
                    placeholder="masukan jabatan"
                    value={jabatan}
                    onChange={(e) => setJabatan(e.target.value)}
                  />
                  {errors.jabatan && (
                    <small className="allValidasiError">
                      {errors.jabatan.message}
                    </small>
                  )}
                </div>
              </div>

              <div className="field">
                <label className="label">Tanggal SK</label>
                <div className="control">
                  <Form.Group controlId="duedate" className="dtp">
                    <Form.Control
                      type="date"
                      name="duedate"
                      placeholder="Tanggal SK"
                      value={tglSK}
                      onChange={(e) => setTglSK(e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="field">
                <label className="label">Status Jabatan</label>
                <div className="control">
                  <div className="select is-fullwidth">
                    <select
                      className="dropdown"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      required
                      disabled="true"
                    >
                      <option>Pengajuan Sertifikat Jabatan</option>
                      <option>Disetujui Kabid Kepegawaian</option>
                      <option>Ditolak Kabid Kepegawaian</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="field">
                <label className="label">Sertifikat Jabatan</label>
                <div className="control">
                  <div className="file">
                    <label className="file-label">
                      <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleChange}
                      />
                    </label>
                  </div>
                  <br />
                  <PdfViewer fileUrl={fileUrl} />
                </div>
              </div>

              <br />
              <div className="field">
                <div className="control">
                  <button type="submit" className="button is-success">
                    Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormAddRiwayatJabatan;
